<div class="auth-modal-err">

  <button type="button" class="auth-modal-err__close-btn"></button>

  <h2 class="auth-modal-err__form--title">Error</h2>

  <p class="auth-modal-err__text">User with this email already exists</p>

</div>